import { baseApi } from '@/lib/utils'

export interface EntitlementTier {
  min_years: number
  max_years: number | null
  days_per_month: number
}

export interface NoticeTier {
  max_days: number | null
  notice_days: number
}

export interface LeavePolicy {
  entitlement_tiers: EntitlementTier[]
  probation_gate_enabled: boolean
  special_leave_days: number
  notice_tiers: NoticeTier[]
  weekly_off_days: number[]
  sandwich_rule_enabled: boolean
  updated_at: string
}

export interface LeavePolicyResponse {
  success: boolean
  data: LeavePolicy
}

export type UpdateLeavePolicyPayload = Omit<LeavePolicy, 'updated_at'>

export const leavePolicyApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getLeavePolicy: builder.query<LeavePolicyResponse, void>({
      query: () => ({ url: '/leave-policy' }),
      providesTags: ['LeavePolicy'],
    }),

    updateLeavePolicy: builder.mutation<
      { success: boolean; message: string },
      UpdateLeavePolicyPayload
    >({
      query: body => ({
        url: '/leave-policy',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['LeavePolicy'],
    }),
  }),
})

export const { useGetLeavePolicyQuery, useUpdateLeavePolicyMutation } =
  leavePolicyApi
